import React from "react";
import { Route, Switch } from "react-router-dom";

import { GetEbsOrderPayloadForm } from "./ebs-order-payload";

export default () => {
    return {
        routes: [
            {
                path: "/test-harnesses",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}/ebs-order-payload`}
                            exact
                            component={GetEbsOrderPayloadForm}
                        />
                    </Switch>
                ),
            },
        ],
    };
};
